import { render, staticRenderFns } from "./TablePlaceholder.vue?vue&type=template&id=b8ae983c"
import script from "./TablePlaceholder.vue?vue&type=script&lang=js"
export * from "./TablePlaceholder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports